import React, { useState } from "react";
import "../CSS/EditProfileTenagaKesehatan.css";
import { useNavigate } from "react-router-dom";

function EditProfileTenagaKesehatanAdmin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nama: "Megumi Fushiguro",
    email: "drfushiguro.megumi@gmail.com",
    telepon: "085231256566",
    spesialisasi: "Paru-paru",
    str: "1456789065432",
    faskes: "RSUD Magetan",
    nip: "45678987657121",
    profesi: "Dokter",
  });

  // handle perubahan input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // handle simpan perubahan
  const handleSave = () => {
    console.log("Data baru:", formData);
    alert("Perubahan berhasil disimpan!");
    navigate("/HalamanDetailTenagaKesehatan");
  };

  // handle batal
  const handleCancel = () => {
    navigate("/HalamanEditProfileTenagaKesehatan");
  };

    const handleAktivitasClick = () => {
    navigate("/HalamanAktivitasTenagaKesehatanAdmin"); 
  };

  return (
    <div className="profile-page">
      <div className="main-contentprofile">
        <div className="content-profile">
          <div className="profile-card">
            <div className="profile-avatar">NK</div>
            <div className="profile-info">
              <h3>{formData.nama}</h3>
              <p>Dokter Spesialis Paru - RSUD Magetan</p>
              <p className="nip">NIP. {formData.nip}</p>
            </div>
          </div>

          <div className="tab-section">
            <button className="tab active">Informasi</button>
            <button className="tab"  onClick={handleAktivitasClick}>Aktivitas</button>
          </div>

          <div className="form-sectionprofile">
            <div className="form-row">
              <div className="form-groupprofile">
                <label>Nama Lengkap</label>
                <input
                  type="text"
                  name="nama"
                  value={formData.nama}
                  onChange={handleChange}
                />
              </div>
              <div className="form-groupprofile">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>No. Telepon</label>
                <input
                  type="text"
                  name="telepon"
                  value={formData.telepon}
                  onChange={handleChange}
                />
              </div>
              <div className="form-groupprofile">
                <label>Spesialisasi</label>
                <input
                  type="text"
                  name="spesialisasi"
                  value={formData.spesialisasi}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>No. STR</label>
                <input
                  type="text"
                  name="str"
                  value={formData.str}
                  onChange={handleChange}
                />
              </div>
              <div className="form-groupprofile">
                <label>Alamat Fasilitas Kesehatan</label>
                <input
                  type="text"
                  name="faskes"
                  value={formData.faskes}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>NIP</label>
                <input
                  type="text"
                  name="nip"
                  value={formData.nip}
                  onChange={handleChange}
                />
              </div>
              <div className="form-groupprofile">
                <label>Profesi</label>
                <input
                  type="text"
                  name="profesi"
                  value={formData.profesi}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Tombol Simpan & Batal */}
            <div className="btn-edit-container">
              <button className="save-btn" onClick={handleSave}>
                Simpan Perubahan
              </button>
              <button className="cancel-btn" onClick={handleCancel}>
                Batal
              </button>
            </div>
          </div>

          <footer className="footerdebar">
            © 2025 TibiSmart. All rights reserved.
          </footer>
        </div>
      </div>
    </div>
  );
}

export default EditProfileTenagaKesehatanAdmin;
